module.exports = __webpack_public_path__ + "static/bg-c94de5530a134b2642aea8695f4882b0.png";